<template>
  <div class="cmp-header" :class="{'home': activeMenu === '/home', 'menu':showMenu}">
    <div class="header-box">
      <div class="header-left">
        <!-- <img class="logo g-pointer" src="~@images/logo.png" alt @click="goHome"> -->
        <h1 @click="goHome">长春博物馆</h1>
        <p class="eng">CHANGCHUN MUSEUM</p>
      </div>

      <!-- text-color="#000"
      active-text-color="#9C4040" -->
      <!-- <el-menu style="display:none;" :default-active="activeMenu" menu-trigger="click" class="el-menu-top1"
        mode="horizontal" @select="handleSelect" background-color="transparent">
        <template v-for="(item, index) in menus.slice(0,9)">
          <el-menu-item class="m-menu-top" :index="item.path" :key="index"
            v-if="!item.children">{{item.title}}</el-menu-item>

          <template v-else>
            <el-submenu popper-class="dl-wrapper" :index="item.path" class="my-submenu" :key="index"
              :popper-append-to-body="true">
              <template slot="title">{{item.title}}</template>
              <div class="aaa" style="display: flex;">
                <el-menu-item :index="it.path" :key="i" v-for="(it, i) in item.children">
                  <span class="span-wrapper" :class="{'active': it.path == activePath}"
                    @click="subMenuClk(it)"><span>{{it.title}}</span><img src="../../assets/images/icon_open@2x.png"
                      alt=""></span>
                </el-menu-item>
              </div>
            </el-submenu>
          </template>
        </template>

     <el-submenu index="2" v-show="menus.length>9">
          <template slot="title">更多</template>
          <el-menu-item
            class="m-menu-top"
            :index="item.path"
            :key="index"
            v-for="(item, index) in menus.slice(9)"
          >{{item.title}}</el-menu-item>
        </el-submenu> 
      </el-menu> -->
      <div class="operate">
        <router-link tag="a" :to="'/search'" class="btn-search"><i></i></router-link>
        <!-- <router-link tag="a" :to="'/video'" class="btn-search btn-video"><i></i></router-link> -->
        <span class="icon-menu ml-10" :class="{'icon-close': showMenu}" @click="handleShow"><i></i></span>

        <!-- <cmpNoticeCenter ref="cmpNoticeCenter"></cmpNoticeCenter> -->

        <!-- <i class="el-icon el-icon-search g-pointer" v-if="!showSearch" @click="showSearch=true;blurFocus=true;"></i> -->
        <!-- <i class="el-icon el-icon-search g-pointer" v-if="!showSearch" @click="showSearchBox"></i> -->

        <!-- <el-input ref="customerInput" suffix-icon="el-icon-search"
          style="width:300px;position:absolute;right: 100px;top: 10px;z-index: 2;" placeholder="输入关键字"
          @keyup.enter.native="goSearch" @blur="showSearch=false" v-if="showSearch" v-model="key"></el-input> -->

        <!-- <el-upload
          class="g-inline-block"
          action="/singleMuseum/user/updateUserImg"
          accept="image/*"
          :data="configData"
          :show-file-list="false"
          :before-upload="beforeAvatarUpload"
          :on-success="handleAvatarSuccess"
        >
          <img
            class="g-pic small"
            :src="$store.state.user.headImg || ''"
            alt
            :onerror="defaultHeadImg"
          >
        </el-upload> 
        
        <label class="person ml-10">
          <span class="name m-assist ell">{{$store.state.user.userName}}</span>
        </label>
        
        <span class="m-assist ml-20 g-pointer" @click="loginOut">退出</span>-->

        <!-- 菜单 -->

        <!-- <div class="login g-pointer" @click="goLogin" v-if="!$store.state.user.userName"><span>登录</span></div>
        <el-dropdown trigger="click" @command="handleOperate" v-else>
          <div class="head-img-box">
            <img :src="$store.state.user.headImg || ''"
              alt
              :onerror="defaultHeadImg"
            >
            <label class="person ml-10">
              <span class="name m-assist ell">{{$store.state.user.userName}}</span>
            </label>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="1">个人中心</el-dropdown-item>
            <el-dropdown-item command="2">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown> -->
      </div>
    </div>

    <!-- @click="showMenu=false" -->
    <!--  @select="handleSelect" @touchmove.prevent -->
    <div class="overlay">
      <div class="menu-box" :class="{'anim': showMenu}">
        <el-menu class="el-menu-top" 
          :default-active="activeMenu" 
          @select="handleSelect"  
          background-color="#1C1E24" 
          text-color="#fff"
          active-text-color="#ffd04b" 
          router>
          <template v-for="(item, index) in menus">
            <!--1级菜单：当有子菜单时-->
            <template v-if="item.children">
              <el-submenu :index="item.path" :key="index">
                <!--1级菜单名-->
                <template slot="title">
                  <span slot="title"  class="pl-0" >{{ item.title }}</span>
                </template>

                <template v-for="(subItem,i) in item.children">
                  <!--2级菜单：当有子菜单时-->
                  <template v-if="subItem.children">
                    <el-submenu :index="subItem.path" :key="i">
                      <!--2级菜单名-->
                      <template slot="title">
                        <span slot="title" class="pl-40">{{ subItem.title }}</span>
                      </template>
                      <template v-for="(ThreeItem,j) in subItem.children">
                        <!--3级菜单名-->
                        <el-menu-item :index="ThreeItem.path"   :key="j">
                          <span class="pl-80">
                            {{ ThreeItem.title }}
                          </span>
                        </el-menu-item>
                      </template>
                    </el-submenu>
                  </template>
                  <!--2级菜单：当无子菜单时-->
                  <template v-else>
                    <!--2级菜单名-->
                    <el-menu-item :index="subItem.path" :key="i">
                      <span slot="title" class="pl-40">{{ subItem.title }}</span>
                    </el-menu-item>
                  </template>
                </template>
              </el-submenu>
            </template>
            <!--1级菜单：当无子菜单时-->
            <template v-else>
              <!--1级菜单名-->
              <el-menu-item class="m-menu-top pl-0" :index="item.path" :key="index">
                <span slot="title">{{ item.title }}</span>
              </el-menu-item>
            </template>
          </template>
        </el-menu>
      </div>
      <!-- <div class="menu-box">
        <el-menu :default-active="activeMenu" menu-trigger="click" class="el-menu-top" mode="horizontal"
          @select="handleSelect" background-color="transparent">
          <template v-for="(item, index) in menus.slice(0,9)">
            <el-menu-item class="m-menu-top" :index="item.path" :key="index"
              v-if="!item.children">{{item.title}}</el-menu-item>

            <template v-else>
              <el-submenu popper-class="dl-wrapper" :index="item.path" class="my-submenu" :key="index"
                :popper-append-to-body="true">
                <template slot="title">{{item.title}}</template>
                <div class="aaa" style="display: flex;">
                  <el-menu-item :index="it.path" :key="i" v-for="(it, i) in item.children">
                    <span class="span-wrapper" :class="{'active': it.path == activePath}"
                      @click="subMenuClk(it)"><span>{{it.title}}</span><img src="../../assets/images/icon_open@2x.png"
                        alt=""></span>
                  </el-menu-item>
                </div>
              </el-submenu>
            </template>
          </template>

          <el-submenu index="2" v-show="menus.length>9">
            <template slot="title">更多</template>
            <el-menu-item
              class="m-menu-top"
              :index="item.path"
              :key="index"
              v-for="(item, index) in menus.slice(9)"
            >{{item.title}}</el-menu-item>
          </el-submenu>
        </el-menu>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'Header',
  data() {
    return {
      blurFocus: true,
      activePath: '',
      defaultHeadImg: this.$store.state.app.defaultHeadImg,
      // activeMenu: this.$route.path,
      activeMenu: '/' + this.$route.path.split('/')[1],
      key: '',
      showSearch: false,
      menus: [
        {
          title: '首页',
          path: '/home'
        },
        {
          title: '陈列展览',
          path: '/exhibition'
        },
        {
          title: '馆藏精品',
          path: '/collect'
        },
        // {
        //   title: '资讯动态',
        //   path: '/information'
        // },
        {
          title: '社会教育',
          path: '/activity'
        },
        // {
        //   title: '文创产品',
        //   path: '/product'
        // },
        // {
        //   title: '视频资源',
        //   path: '/video',
        // },
        {
          title: '通知公告',
          path: '/notice',
        },
        {
          title: '关于我们',
          path: '/about',
        },
        // {
        //   title: '参观',
        //   path: '/visit',
        //   // children: [
        //   //   {
        //   //     title: '当前展览',
        //   //     path: '/exhibition',
        //   //   },
        //   //   {
        //   //     title: '数字展厅',
        //   //     path: '/exhibition/digital',
        //   //   },
        //   //   {
        //   //     title: '观众策展',
        //   //     path: '/exhibition/curation',
        //   //   }
        //   // ]
        // },
        
        // {
        //   title: '公众服务',
        //   path: '/service'
        // },
        // {
        //   title: '文化',
        //   path: '/culture'
        // }
      ],
      showMenu: false
    }
  },
  watch: {
    // $route(to, from) {
    //   if (to.path.indexOf('museum') == -1) {
    //     // this.activePath = ""
    //   } else {
    //   }
    //   if (this.$route.path === '/alliance/detail') {
    //     // 1 联盟详情  2 企业展会-产品详情  3 企业展会-案例详情
    //     let pageType = this.$route.query.pageType
    //     switch (pageType) {
    //       case '1':
    //         this.activeMenu = '/alliance'
    //         break
    //       case '2':
    //       case '3':
    //         this.activeMenu = '/enterprise'
    //         break
    //     }
    //     return
    //   }

    //   this.activeMenu = '/' + this.$route.path.split('/')[1]
    // }
  },
  methods: {
    handleShow() {
      this.showMenu = !this.showMenu
      if (this.showMenu) {
        this.stopScroll()
      } else {
        this.canScroll()
      }
    },
    subMenuClk(it) {
      this.activePath = it.path
      console.log(it)
    },
    handleOperate(val) {
      if (val === '1') {
        this.$router.push({ path: '/person' })
      } else if (val === '2') {
        this.loginOut()
      }
    },
    goHome() {
      this.$router.push({
        path: '/home'
      })
    },
    goLogin() {
      this.$router.push({
        path: '/login'
      })
    },
    goSearch() {
      console.log('搜索', this.key)
    },
    // 显示搜索框
    showSearchBox() {
      this.showSearch = true
      this.$nextTick(() => {
        this.$refs.customerInput.$el.querySelector('input').focus()
      })
    },
    handleSelect(key) {
      // handleSelect(key, keyPath) {
      // if (key === '/home') {
      //   // if(key === '/approve' || key === '/home' || key === '/digital') {
      //   // this.$message.warning('建设中')
      //   return
      // }
      this.showMenu = false
      this.canScroll()
      this.$router.push(key)
    },
    loginOut() {
      this.$store.dispatch('LoginOut')
      this.$router.push({ path: '/login' })
    }
  }
}
</script>

<style lang="scss" scoped>
.cmp-header {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 12;
  width: 100%;
  // height: $headerHeight;
  height: 55px;
  background: rgba(#1C1E24, 1);
  // background: #1C1E24;
  display: flex;
  flex-direction: column;
  align-items: center;
  // box-shadow: 0 3px 8px 2px #f0f4f740;
  &.menu {
    height: 100vh;
  }

  .pl-0{
    padding-left: 0 !important;
  }

  .pl-40{
    padding-left: 40px !important;
  }

  .pl-60{
    padding-left: 60px !important;
  }

  .pl-80{
    padding-left: 80px !important;
  }
  // &.home {
  //   position: absolute;
  //   background: rgba($color: #000, $alpha: 0.5);
  //   /deep/ .el-menu--horizontal > .el-menu-item,
  //   /deep/ .el-menu--horizontal > .el-submenu .el-submenu__title {
  //     color: #fff;
  //   }
  //   .operate {
  //     color: #fff;
  //     .name{
  //       color: #fff;
  //     }
  //   }
  // }
  .header-box {
    flex-shrink: 0;
    position: relative;
    width: 100%;
    height: 55px;
    overflow: hidden;
    padding: 0 18px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .icon-menu {
    // width: 100px;
    padding: 10px;
    box-sizing: border-box;
    display: flex;
    i {
      display: inline-block;
      width: 22px;
      height: 20px;
      background: url(~@images/icon_expand@2x.png) no-repeat center center;
      background-size: 100% 100%;
    }
    &.icon-close {
      i {
        width: 22px;
        height: 22px;
        background: url(~@images/icon-close.png) no-repeat center center;
        background-size: 100% 100%;
      }
    }
  }
  .btn-search {
    // width: 100px;

    display: flex;
    align-items: center;
    justify-content: end;
    height: 25px;
    line-height: 25px;
    padding: 10px;
    i {
      // margin-right: 10px;
      width: 22px;
      height: 22px;
      background: url(~@images/icon_search@2x.png) no-repeat center center;
      background-size: contain;
    }
    &.btn-video {
      i {
        background: url(~@images/icon_video.png) no-repeat center center;
        background-size: contain;
      }
    }
  }
  .header-left {
    display: flex;
    flex-direction: column;
    // align-items: center;
    // padding-left: 20px;
    // margin-right: 30px;
    .logo {
      margin-top: 5px;
      width: 125px;
      // width: 319px;
      // height: 91px;
    }
    h1 {
      display: inline-block;
      color: #fff;
      font-size: 18px;
      font-weight: bold;
      font-family: '黑体';
      margin-bottom: 0;
      letter-spacing: 9px;
    }
    .eng {
      color: #fff;
      font-size: 11px;
    }
  }
  .head-pic {
    width: 20px;
    height: 20px;
    border-radius: 100%;
  }
  .el-menu-top {
    flex: 1;
    border: none;
    display: flex;
    justify-content: center;
  }
  .operate {
    // padding-right: 40px;
    // width: 130px;
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #000;
    .el-icon {
      margin-right: 18px;
    }
    .head-img-box {
      display: inline-block;
      outline: none;
      cursor: pointer;
      img {
        width: 12px;
        height: 12px;
        vertical-align: middle;
        border-radius: 100%;
      }
    }
    .person {
      cursor: pointer;
      .name {
        max-width: 45px;
        display: inline-block;
        position: relative;
        top: 3px;
      }
      img {
        margin-right: 5px;
        display: inline-block;
        width: 20px;
        height: 20px;
        vertical-align: middle;
        border-radius: 100%;
      }
    }
  }
}
.overlay {
  box-sizing: border-box;
  width: 100%;
  height: 0;
  flex: 1;
  margin-bottom: 20px;
}
.menu-box {
  position: fixed;
  bottom: 0;
  // left: 0;
  // top: $headerHeight;
  top: 55px;
  // overflow: hidden;
  margin-top: 12px;
  border-top: 1px solid rgba($color: #000000, $alpha: 0.2);
  overflow: auto;
  z-index: 100;
  width: 100%;
  padding: 0 18px;
  // height: 100%;
  height: 0;
  background: #1C1E24;
  box-sizing: border-box;
  transition: all .3s;
  opacity: 0;
  &::-webkit-scrollbar {
    display: none;
    width: 0 !important;
  }
  .el-menu-top {
    display: flex;
    flex-direction: column;
    .el-menu-item,
    /deep/.el-submenu > .el-submenu__title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      background: none !important;
      height: auto;
      line-height: 30px;
      padding: 15px 0;
      padding-left: 0 !important;
      position: relative;
      font-size: 18px;
      text-align: left;
      border-width: 4px;
      border-bottom: 1px solid rgba($color: #ffffff, $alpha: 0.2);
      .el-submenu__icon-arrow {
        position: relative;
        font-size: 20px;
        color: #fff;
        font-weight: bold;
      }
    }
  }
  &.anim {
    opacity: 1;
    height: calc(100% - 70px);
  }
}
</style>

